import { BUSCAR_ROTAS_IMPORTACAO, LIMPAR_ROTAS_IMPORTACAO } from '../../actions/types'

const initialState = undefined;

const estadoRotasParaImportacao = {
    rotas: []
}

export default function reducerImportarRotas (state = estadoRotasParaImportacao, action = initialState) {
  switch (action.type) {    

    case BUSCAR_ROTAS_IMPORTACAO: {
        const rotas = action.payload.data;        
        if (rotas) {          
          return {
            ...state,
            rotas: rotas.rotas
          }
        }
        return {
            ...state,
            rotas: []
        }
      }

    case LIMPAR_ROTAS_IMPORTACAO: {
      return estadoRotasParaImportacao;
    }

    default: {
      return state
    }
  }
}
